import { render, staticRenderFns } from "./duo_otel_info.vue?vue&type=template&id=52d39850&vue3"
import script from "./duo_otel_info.vue?vue&type=script&lang=js&vue3"
export * from "./duo_otel_info.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports